import { render, staticRenderFns } from "./steps4.vue?vue&type=template&id=1652906b&scoped=true&"
import script from "./steps4.vue?vue&type=script&lang=js&"
export * from "./steps4.vue?vue&type=script&lang=js&"
import style0 from "./steps4.vue?vue&type=style&index=0&id=1652906b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652906b",
  null
  
)

export default component.exports